/* eslint-disable unicorn/no-array-for-each */
/* eslint-disable @typescript-eslint/no-unused-expressions */
/* eslint-disable unicorn/catch-error-name */
import ngDeps from "ng-react-directives/ngr-injector";
import { put, call, takeEvery, select } from "redux-saga/effects";
import { toast } from "react-toastify";

import Api from "api/externalApproval";
import collabApi from "api/collaboration";
import { handleError } from "utils/handleError";

import {
  BULK_CHANGE_COLLAB_STATE_ROUTINE,
  CHANGE_COLLAB_STATE_ROUTINE,
  INIT_EXTERNAL_COLLAB_ROUTINE,
  ADD_EXTERNAL_COLLAB_THEME_ROUTINE,
  UPDATE_EXTERNAL_COLLAB_THEME_ROUTINE,
  DELETE_EXTERNAL_COLLAB_THEME_ROUTINE,
  ADD_EXTERNAL_COLLAB_LINK_ROUTINE,
  UPDATE_EXTERNAL_COLLAB_LINK_ROUTINE,
  DELETE_EXTERNAL_COLLAB_LINK_ROUTINE,
  GET_COLLABORATION_COMMENTS_ROUTINE,
  GET_COLLABORATION_USERS_ROUTINE,
  GET_COLLABORATION_UNREADS_COUNT_ROUTINE,
  ADD_COLLABORATION_COMMENT_ROUTINE,
  EDIT_COLLABORATION_COMMENT_ROUTINE,
  DELETE_COLLABORATION_COMMENT_ROUTINE,
  COLLABORATION_COMMENTS_LOADING_ON,
  COLLABORATION_COMMENTS_LOADING_OFF,
  NEW_UNREAD_NOTIFICATION_RECEIVED,
} from "constants/ActionTypes";
import { reloadPosts as reloadPostsAction } from "actions/postsView";
import {
  ColCollaborator,
  ColCommentMetadata,
  ColComments,
  ColCommentVisibility,
  ColLink,
  ColTheme,
} from "../components/Collaboration/types";
import { ReduxRootState } from "../types/redux-store";

const eaApi = new Api();

export function* changeCollabState(action: {
  type: { type: string };
  payload: {
    postIds: string[];
    postType: string;
    key: string;
    callback: (ap?: string) => void;
  };
}) {
  const { type } = action.type;
  const routine =
    type === BULK_CHANGE_COLLAB_STATE_ROUTINE.TRIGGER
      ? BULK_CHANGE_COLLAB_STATE_ROUTINE
      : CHANGE_COLLAB_STATE_ROUTINE;
  const { postIds, postType, key, callback } = action.payload;
  const { collaborationService } = ngDeps;

  yield put({ type: routine.REQUEST });

  // This was running on bulk change collab state before call (drafts | activities)
  // if (!post.schedule.channel || post.schedule.channel === "")
  //   post.schedule.channel = post._id;
  try {
    yield call(
      collaborationService.updatePostStatusKey,
      postIds,
      postType,
      key
    );
    yield put({
      type: routine.SUCCESS,
      payload: {
        postIds: postIds,
        postType: postType,
        postStatusKey: key,
      },
    });
    yield put(reloadPostsAction());

    toast.success("Post Status was successfully updated.");
  } catch (err) {
    console.error("Err updating post status", err);
    toast.error("Post Status was not updated.");

    yield put({
      type: routine.FAILURE,
      error: true,
      payload: err,
    });
  }

  callback && callback();
}

export function* initExternalCollab() {
  yield put({
    type: INIT_EXTERNAL_COLLAB_ROUTINE.REQUEST,
    payload: {},
  });

  try {
    const themes: { data: ColTheme[] } = yield call(
      eaApi.getExternalCollabThemes
    );

    const links: { data: ColLink[] } = yield call(eaApi.getExternalCollabLinks);

    // create object for use in table
    links.data.forEach((link) => {
      link.states = {
        review: link.showPostWithState,
        approve: link.acceptState,
        reject: link.rejectState,
      };
    });
    yield put({
      type: INIT_EXTERNAL_COLLAB_ROUTINE.SUCCESS,
      payload: { themes: themes.data, links: links.data },
    });
  } catch (err) {
    yield put({
      type: INIT_EXTERNAL_COLLAB_ROUTINE.FAILURE,
      error: true,
      payload: err,
    });
    // in case it is permissions related, we can get a new token any time
    localStorage.removeItem("skedApiToken");
    handleError(err);
  }
}
export function* addExternalCollabTheme(action: {
  type: { type: string };
  payload: { theme: ColTheme };
}) {
  let { theme } = action.payload;
  yield put({
    type: ADD_EXTERNAL_COLLAB_THEME_ROUTINE.REQUEST,
    payload: {
      theme,
    },
  });
  try {
    const themeResult: { data: ColTheme } = yield call(
      eaApi.createTheme,
      theme.name,
      theme.imageUrl,
      theme.companyName
    );
    theme = themeResult.data;
    yield put({
      type: ADD_EXTERNAL_COLLAB_THEME_ROUTINE.SUCCESS,
      payload: { theme },
    });
  } catch (err) {
    yield put({
      type: ADD_EXTERNAL_COLLAB_THEME_ROUTINE.FAILURE,
      error: true,
      payload: err,
    });
    handleError(err);
  }
}
export function* updateExternalCollabTheme(action: {
  type: { type: string };
  payload: { theme: ColTheme };
}) {
  const { theme } = action.payload;
  yield put({
    type: UPDATE_EXTERNAL_COLLAB_THEME_ROUTINE.REQUEST,
    payload: {
      theme,
    },
  });
  try {
    yield call(
      eaApi.updateTheme,
      theme._id,
      theme.name,
      theme.imageUrl,
      theme.companyName
    );
    yield put({
      type: UPDATE_EXTERNAL_COLLAB_THEME_ROUTINE.SUCCESS,
      payload: { theme },
    });
  } catch (err) {
    yield put({
      type: UPDATE_EXTERNAL_COLLAB_THEME_ROUTINE.FAILURE,
      error: true,
      payload: err,
    });
    handleError(err);
  }
}
export function* deleteExternalCollabTheme(action: {
  type: { type: string };
  payload: { id: string };
}) {
  const { id } = action.payload;
  yield put({
    type: DELETE_EXTERNAL_COLLAB_THEME_ROUTINE.REQUEST,
    payload: {
      id,
    },
  });

  try {
    yield call(eaApi.deleteTheme, id);
    yield put({
      type: DELETE_EXTERNAL_COLLAB_THEME_ROUTINE.SUCCESS,
      payload: { id },
    });
  } catch (err) {
    yield put({
      type: DELETE_EXTERNAL_COLLAB_THEME_ROUTINE.FAILURE,
      error: true,
      payload: err,
    });
    handleError(err);
  }
}
export function* addExternalCollabLink(action: {
  type: { type: string };
  payload: { link: ColLink };
}) {
  let { link } = action.payload;
  yield put({
    type: ADD_EXTERNAL_COLLAB_LINK_ROUTINE.REQUEST,
    payload: {
      link,
    },
  });
  try {
    const result: { data: ColLink } = yield call(eaApi.createLink, link);
    link = result.data;
    yield put({
      type: ADD_EXTERNAL_COLLAB_LINK_ROUTINE.SUCCESS,
      payload: { link },
    });
  } catch (err) {
    yield put({
      type: ADD_EXTERNAL_COLLAB_LINK_ROUTINE.FAILURE,
      error: true,
      payload: err,
    });
    handleError(err);
  }
}
export function* updateExternalCollabLink(action: {
  type: { type: string };
  payload: { link: ColLink };
}) {
  let { link } = action.payload;
  yield put({
    type: UPDATE_EXTERNAL_COLLAB_LINK_ROUTINE.REQUEST,
    payload: {
      link,
    },
  });
  try {
    const result: { data: ColLink } = yield call(eaApi.updateLink, link);
    link = result.data;
    yield put({
      type: UPDATE_EXTERNAL_COLLAB_LINK_ROUTINE.SUCCESS,
      payload: { link },
    });
  } catch (err) {
    yield put({
      type: UPDATE_EXTERNAL_COLLAB_LINK_ROUTINE.FAILURE,
      error: true,
      payload: err,
    });
    handleError(err);
  }
}
export function* deleteExternalCollabLink(action: {
  type: { type: string };
  payload: { id: string };
}) {
  const { id } = action.payload;
  yield put({
    type: DELETE_EXTERNAL_COLLAB_LINK_ROUTINE.REQUEST,
    payload: {
      id,
    },
  });

  try {
    yield call(eaApi.deleteLink, id);
    yield put({
      type: DELETE_EXTERNAL_COLLAB_LINK_ROUTINE.SUCCESS,
      payload: { id },
    });
  } catch (err) {
    yield put({
      type: DELETE_EXTERNAL_COLLAB_LINK_ROUTINE.FAILURE,
      error: true,
      payload: err,
    });
    handleError(err);
  }
}

export function* getCollaborationComments(action: {
  type: { type: string };
  payload: { channelId: string };
}) {
  const { channelId } = action.payload;
  yield loadingOn(channelId);

  try {
    const { data }: { data: ColComments } = yield call(
      collabApi.getComments,
      channelId
    );
    yield put({
      type: GET_COLLABORATION_COMMENTS_ROUTINE.SUCCESS,
      payload: { channelId, comments: data },
    });
  } catch (err) {
    yield put({
      type: GET_COLLABORATION_COMMENTS_ROUTINE.FAILURE,
      error: true,
      payload: err,
    });
    handleError(err);
  } finally {
    yield loadingOff(channelId);
  }
}

export function* getCollaborationUsers() {
  try {
    const { data }: { data: ColCollaborator[] } = yield call(
      collabApi.getCollaborators
    );
    yield put({
      type: GET_COLLABORATION_USERS_ROUTINE.SUCCESS,
      payload: data,
    });
  } catch (err) {
    yield put({
      type: GET_COLLABORATION_USERS_ROUTINE.FAILURE,
      error: true,
      payload: err,
    });
    handleError(err);
  }
}
export function* getCollaborationUnreadsCount() {
  yield put({
    type: GET_COLLABORATION_UNREADS_COUNT_ROUTINE.REQUEST,
  });
  try {
    const { data } = yield call(collabApi.getUnreads);
    yield put({
      type: GET_COLLABORATION_UNREADS_COUNT_ROUTINE.SUCCESS,
      payload: data,
    });
  } catch (err) {
    yield put({
      type: GET_COLLABORATION_UNREADS_COUNT_ROUTINE.FAILURE,
      error: true,
      payload: err,
    });
    handleError(err);
  }
}

export function* addCollaborationComment(action: {
  type: { type: string };
  payload: {
    channelId: string;
    body: string;
    metadata?: ColCommentMetadata;
    visibility: ColCommentVisibility;
    done?: () => void;
    onError?: (err: unknown) => void;
  };
}) {
  const { channelId, body, metadata, visibility, done, onError } =
    action.payload;
  yield loadingOn(channelId);

  try {
    yield call(collabApi.addComment, channelId, {
      body,
      metadata,
      visibility,
    });
    done && done();
  } catch (err) {
    (onError || handleError)(err);
  } finally {
    yield loadingOff(channelId);
  }
}

export function* editCollaborationComment(action: {
  type: { type: string };
  payload: {
    channelId: string;
    commentId: string;
    body: string;
    visibility: ColCommentVisibility;
    done?: () => void;
    onError?: (err: unknown) => void;
  };
}) {
  const { channelId, commentId, body, visibility, done, onError } =
    action.payload;
  yield loadingOn(channelId);

  try {
    yield call(collabApi.editComment, channelId, commentId, {
      body,
      visibility,
    });
    done && done();
  } catch (err) {
    (onError || handleError)(err);
  } finally {
    yield loadingOff(channelId);
  }
}

export function* deleteCollaborationComment(action: {
  type: { type: string };
  payload: {
    channelId: string;
    commentId: string;
    done?: () => void;
  };
}) {
  const { channelId, commentId, done } = action.payload;
  yield loadingOn(action.payload.channelId);
  try {
    yield call(collabApi.deleteComment, channelId, commentId);
  } catch (err) {
    handleError(err);
  } finally {
    yield loadingOff(channelId);
    done && done();
  }
}

export function* newUnreadNotificationReceived(action: {
  type: { type: string };
  payload: { channelId: string };
}) {
  const { channelId } = action.payload;
  const activeChannelIds: string[] = yield select((state: ReduxRootState) =>
    Object.keys(state.entities.colActiveChannels)
  );

  yield put({
    type: NEW_UNREAD_NOTIFICATION_RECEIVED.SUCCESS,
    payload: { channelId, activeChannelIds },
  });
}

function* loadingOn(channelId: string) {
  yield put({
    type: COLLABORATION_COMMENTS_LOADING_ON,
    payload: { channelId },
  });
}

function* loadingOff(channelId: string) {
  yield put({
    type: COLLABORATION_COMMENTS_LOADING_OFF,
    payload: { channelId },
  });
}

export default function* collaborationSagas() {
  yield takeEvery(BULK_CHANGE_COLLAB_STATE_ROUTINE.TRIGGER, changeCollabState);
  yield takeEvery(CHANGE_COLLAB_STATE_ROUTINE.TRIGGER, changeCollabState);
  yield takeEvery(INIT_EXTERNAL_COLLAB_ROUTINE.TRIGGER, initExternalCollab);
  yield takeEvery(
    ADD_EXTERNAL_COLLAB_THEME_ROUTINE.TRIGGER,
    addExternalCollabTheme
  );
  yield takeEvery(
    UPDATE_EXTERNAL_COLLAB_THEME_ROUTINE.TRIGGER,
    updateExternalCollabTheme
  );
  yield takeEvery(
    DELETE_EXTERNAL_COLLAB_THEME_ROUTINE.TRIGGER,
    deleteExternalCollabTheme
  );
  yield takeEvery(
    ADD_EXTERNAL_COLLAB_LINK_ROUTINE.TRIGGER,
    addExternalCollabLink
  );
  yield takeEvery(
    UPDATE_EXTERNAL_COLLAB_LINK_ROUTINE.TRIGGER,
    updateExternalCollabLink
  );
  yield takeEvery(
    DELETE_EXTERNAL_COLLAB_LINK_ROUTINE.TRIGGER,
    deleteExternalCollabLink
  );
  yield takeEvery(
    GET_COLLABORATION_COMMENTS_ROUTINE.TRIGGER,
    getCollaborationComments
  );
  yield takeEvery(
    GET_COLLABORATION_USERS_ROUTINE.TRIGGER,
    getCollaborationUsers
  );
  yield takeEvery(
    GET_COLLABORATION_UNREADS_COUNT_ROUTINE.TRIGGER,
    getCollaborationUnreadsCount
  );
  yield takeEvery(
    ADD_COLLABORATION_COMMENT_ROUTINE.TRIGGER,
    addCollaborationComment
  );
  yield takeEvery(
    EDIT_COLLABORATION_COMMENT_ROUTINE.TRIGGER,
    editCollaborationComment
  );
  yield takeEvery(
    DELETE_COLLABORATION_COMMENT_ROUTINE.TRIGGER,
    deleteCollaborationComment
  );
  yield takeEvery(
    NEW_UNREAD_NOTIFICATION_RECEIVED.TRIGGER,
    newUnreadNotificationReceived
  );
}
